
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import { StockPickingListItem } from "@/models/api/barcodeSystem/barcodeOrders/get";
import { formatDateWithTime, formatBool } from "@/utils";

const barcodeOrderModuleState = getModule(BarcodeOrderModule);

@Component
export default class BarcodeOrderStockPickingTable extends Vue {
  @Prop({ default: false })
  loading: boolean;

  get stockPickings(): Array<StockPickingListItem> {
    return barcodeOrderModuleState.currentBarcodeOrderStockPickings;
  }

  get selectedItemCount(): number {
    return barcodeOrderModuleState.getSelectedBarcodeOrderStockPickingCount;
  }

  get selectedItems(): Array<any> {
    return barcodeOrderModuleState.getSelectedBarcodeOrderStockPickings;
  }

  get totalItems() {
    if (barcodeOrderModuleState.currentBarcodeOrderStockPickings) {
      return barcodeOrderModuleState.currentBarcodeOrderStockPickings.length
    } else {
      return 0;
    }
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val)
  }

  formatBool(val)
  {
    return formatBool(val);
  }

  onDoubleClicked(data) {
  }

  onRowClick(data) {
    barcodeOrderModuleState.switchBarcodeOrderStockPickingSelectionStatus(data.id);
  }

  unselectAll() {
    let items = this.selectedItems;

    items.forEach(item => {
      barcodeOrderModuleState.switchBarcodeOrderStockPickingSelectionStatus(item.id);
    });
  }
}
